const api = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  // system
  user: '/system/user',
  role: '/system/role',
  permission: '/system/menu',
  dept: '/system/dept',
  dictType: '/system/dict/type',
  dictData: '/system/dict/data',
  dist: '/system/districts',
  config: '/system/config',
  oss: '/system/oss',
  donate: '/system/donate',
  models: '/act/models',
  prof: '/act/prof',
  process: '/act/process',
  processIns: '/act/process/ins',
  business: 'act/business',
  leave: 'act/leave',
  feeapply:'act/business_fee_apply',
  reviewapply:'act/review_apply',
  purchase: 'act/purchase_apply',
  reimburse:'act/reimburse_apply',
  node: 'act/node',
  task: 'act/task',
  scrap: 'act/scrapped_apply',
  claim: 'act/claim_apply',
  gateway_system:'/system/',
  gateway_act:'/act/',
  gateway_auth:'/auth/',
}
export default api
